export default __webpack_public_path__ + "static/media/boy2.b30da65a.jpg";